import { onboardingConstants } from "../_constants";

export const nicValidateRequest = (payload) => {
  return {
    type: onboardingConstants.NIC_VALIDATE_REQUEST,
    payload,
  };
};

export const nicValidateComplete = (payload) => {
  return {
    type: onboardingConstants.NIC_VALIDATE_COMPLETE,
    payload,
  };
};

export const nicValidateError = (payload) => {
  return {
    type: onboardingConstants.NIC_VALIDATE_ERROR,
    payload,
  };
};

export const onboardingClearFormData = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_CLEAR_FORM_DATA,
    payload,
  };
};

export const assignRegistrationType = (payload) => {
  return {
    type: onboardingConstants.ASSIGN_REGISTRATION_TYPE,
    payload,
  };
};

export const alternativeFlowRegistrationType = (payload) => {
  return {
    type: onboardingConstants.ALTERNATIVE_FLOW_ASSIGN_REGISTRATION_TYPE,
    payload,
  };
};

export const onboardingClearFormResponseData = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_CLEAR_FORM_RESPONSE_DATA,
    payload,
  };
};

export const debitCardPreRegisterRequest = (payload) => {
  return {
    type: onboardingConstants.DEBIT_CARD_PRE_REGISTER_REQUEST,
    payload,
  };
};

export const debitCardPreRegisterComplete = (payload) => {
  return {
    type: onboardingConstants.DEBIT_CARD_PRE_REGISTER_COMPLETE,
    payload,
  };
};

export const debitCardPreRegisterError = (payload) => {
  return {
    type: onboardingConstants.DEBIT_CARD_PRE_REGISTER_ERROR,
    payload,
  };
};

export const debitCardInitRegisterRequest = (payload) => {
  return {
    type: onboardingConstants.DEBIT_CARD_INIT_REGISTER_REQUEST,
    payload,
  };
};

export const debitCardInitRegisterComplete = (payload) => {
  return {
    type: onboardingConstants.DEBIT_CARD_INIT_REGISTER_COMPLETE,
    payload,
  };
};

export const debitCardInitRegisterError = (payload) => {
  return {
    type: onboardingConstants.DEBIT_CARD_INIT_REGISTER_ERROR,
    payload,
  };
};

export const onboardingOtpResendRequest = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_OTP_RESEND_REQUEST,
    payload,
  };
};

export const onboardingOtpResendComplete = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const onboardingOtpResendError = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_OTP_RESEND_ERROR,
    payload,
  };
};

export const onboardingOtpConfirmRequest = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_OTP_CONFIRM_REQUEST,
    payload,
  };
};

export const onboardingOtpConfirmComplete = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_OTP_CONFIRM_COMPLETE,
    payload,
  };
};

export const onboardingOtpConfirmError = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_OTP_CONFIRM_ERROR,
    payload,
  };
};

export const onboardingUsernameValidateRequest = (payload) => {
  return {
    type: onboardingConstants.USERNAME_VALIDATE_REQUEST,
    payload,
  };
};

export const onboardingUsernameValidateComplete = (payload) => {
  return {
    type: onboardingConstants.USERNAME_VALIDATE_COMPLETE,
    payload,
  };
};

export const onboardingUsernameValidateError = (payload) => {
  return {
    type: onboardingConstants.USERNAME_VALIDATE_ERROR,
    payload,
  };
};

export const assignVerificationType = (payload) => {
  return {
    type: onboardingConstants.ASSIGN_VERIFICATION_TYPE,
    payload,
  };
};

export const backOfficeValidationRequest = (payload) => {
  return {
    type: onboardingConstants.BACKOFFICE_VALIDATION_REQUEST,
    payload,
  };
};

export const backOfficeValidationComplete = (payload) => {
  return {
    type: onboardingConstants.BACKOFFICE_VALIDATION_COMPLETE,
    payload,
  };
};

export const backendValidationError = (payload) => {
  return {
    type: onboardingConstants.BACKOFFICE_VALIDATION_ERROR,
    payload,
  };
};

export const storeProfileWizardDetails = (payload) => {
  return {
    type: onboardingConstants.STORE_PROFILE_WIZARD_DETAILS,
    payload,
  };
};

export const addProfileDataRequest = (payload) => {
  return {
    type: onboardingConstants.ADD_PROFILE_INFO_REQUEST,
    payload,
  };
};

export const addProfileDataComplete = (payload) => {
  return {
    type: onboardingConstants.ADD_PROFILE_INFO_COMPLETE,
    payload,
  };
};

export const addProfileDataError = (payload) => {
  return {
    type: onboardingConstants.ADD_PROFILE_INFO_ERROR,
    payload,
  };
};

export const clearValidateUsernameData = (payload) => {
  return {
    type: onboardingConstants.CLEAR_VALIDATE_USERNAME_DATA,
    payload,
  };
};

export const storeCurrentStepDetails = (payload) => {
  return {
    type: onboardingConstants.STORE_CURRENT_STEP,
    payload,
  };
};

export const onboardingTryAgainFlow = (payload) => {
  return {
    type: onboardingConstants.ONBOARDING_TRY_AGAIN_FLOW,
    payload,
  };
};

export const removeFormDataFeilds = (payload) => {
  return {
    type: onboardingConstants.REMOVE_OWN_FORM_DATA_FIELDS,
    payload,
  };
};
